import feathers from "@feathersjs/client";
import { BASE_URL_API, URL_AUTHENTICATION } from "../constants/index";
const api = feathers();
api.configure(feathers.rest(BASE_URL_API).fetch(window.fetch.bind(window)));
api.configure(
  feathers.authentication({
    path: URL_AUTHENTICATION,
    entity: "user",
    service: "users",
    cookie: "feathers-jwt",
    storageKey: "feathers-jwt",
    storage: window.localStorage
  })
);
export default api;
